import classNames from 'classnames';
import { forwardRef } from 'react';
import { Controls } from './controls';
import { PrimaryInfo } from './primary_info';
const containerIsDisabledCss = "cz1vwg9";
const containerIsErrorCss = "c3ahilc";
const containerIsReadonlyCss = "cghn9po";
const containerCss = "c15xi4ba";
const Container = forwardRef((props, ref) => {
  const {
    isDisabled,
    isError,
    isReadonly,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsDisabledCss]: isDisabled,
    [containerIsErrorCss]: isError,
    [containerIsReadonlyCss]: isReadonly
  }, props.className)} />;
});
export const SelectedLocation = ({
  kind,
  onRemove,
  isDisabled,
  isReadOnly,
  isError,
  notetakerEnabledForEt = false
}) => {
  const showControls = !isReadOnly && !isDisabled && !!onRemove;
  return <Container isDisabled={isDisabled} isReadonly={isReadOnly} data-component="selected-location" isError={isError}>
      <PrimaryInfo kind={kind} notetakerEnabledForEt={notetakerEnabledForEt} />
      {showControls && <Controls onRemove={onRemove} />}
    </Container>;
};

require("./selected_location.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./selected_location.js");